import React from "react";
import Footer from "../Component/Footer/Footer";
import Header from "../Component/Header/Header";
import Createnft from "Pages/Createnft/Createnft";
import Latestupdate from "../Component/Latestupdate/Latestupdate";
import Createnftdigital from "Pages/CreatenftDigital/Createnftdigital";
export default function Createnftthemedigital() {
  return (
    <>
      {/* <Header /> */}
      <Createnftdigital />
      {/* <Latestupdate />
      <Footer /> */}
    </>
  );
}
